import React, {useCallback} from 'react';
import ListItem from '../../../../elements/DEPRECATED_ListItem';
import { useIsMeetingReschedulable } from '../../../../../data/hooks/meeting/useIsMeetingReschedulable';

function RescheduleOption(props) {
    const {event, meeting, i18n} = props,
        isReschedulable = useIsMeetingReschedulable(event.id, meeting);

    const handleReschedule = useCallback(() => {
        app.history.push('../reschedule');
    }, []);

    if (!isReschedulable) return null;

    return (
        <ListItem className="clickable" icon="img/calendar_icon.png" iconColor={event.settings.secondary_color} iconSmall next onClick={handleReschedule}>
            <div className="text main marginTop">{i18n['label.propose-different-time']}</div>
            <div className="text hint">{i18n['hint.propose-different-time']}</div>
        </ListItem>
    );
}

export default RescheduleOption;
